import { useCallback } from 'react'
import CuratedPhotosHeaderForPostPurchaseModal from '../components/CuratedPhotosHeaderForPostPurchaseModal'
import DPFFaqJpSection from '../components/DPFFaqJpSection'
import Footer from '../components/Footer'
import { HeroSectionForPostPurchaseModal } from '../components/HeroSection'
import ProductPricingSection from '../components/ProductPricingSection'
import PurchaseButtons from '../components/PurchaseButtons'
import PurchaseStepsSection from '../components/PurchaseStepsSection'
import AmazonSalesBanner from '../components/AmazonSalesBanner'
import { useAppContext } from '../contexts/AppContext'
import useTracking from '../hooks/useTracking'

export default function PostPurchaseModal() {
  const { isPremiumUser = false, userPhotos = [], premiumDeepLinkUrl = '', api, isAmazonSaleActive = false } = useAppContext()
  const isUsingFallback = userPhotos.length === 0

  const {
    logClickedBuyOnAmazonPostPurchaseModal,
    logClickedBuyOnRakutenPostPurchaseModal,
    logClickedLearnMoreAboutPremiumPostPurchaseModal,
    logClickedPurchaseStepsButtonAmazonPostPurchaseModal,
    logClickedPurchaseStepsButtonRakutenPostPurchaseModal,
  } = useTracking({ api: api || null })

  const handleBuyOnAmazonClick = useCallback(() => {
    logClickedBuyOnAmazonPostPurchaseModal()
  }, [logClickedBuyOnAmazonPostPurchaseModal])

  const handleBuyOnRakutenClick = useCallback(() => {
    logClickedBuyOnRakutenPostPurchaseModal()
  }, [logClickedBuyOnRakutenPostPurchaseModal])

  return (
    <>
      <div className='bg-[#FFFBED] p-4'>ご購入ありがとうございました！</div>

      {isAmazonSaleActive && <AmazonSalesBanner />}

      <header className='relative'>
        <CuratedPhotosHeaderForPostPurchaseModal
          curatedPhotos={userPhotos}
          isUsingFallback={isUsingFallback}
        />
      </header>

      <HeroSectionForPostPurchaseModal />

      <ProductPricingSection
        isPremiumUser={isPremiumUser}
        premiumDeepLinkUrl={premiumDeepLinkUrl}
        logClickedLearnMoreAboutPremium={logClickedLearnMoreAboutPremiumPostPurchaseModal}
      />

      <PurchaseStepsSection
        logClickedPurchaseStepsButtonAmazon={logClickedPurchaseStepsButtonAmazonPostPurchaseModal}
        logClickedPurchaseStepsButtonRakuten={logClickedPurchaseStepsButtonRakutenPostPurchaseModal}
        isAmazonSaleActive={isAmazonSaleActive}
      />

      <DPFFaqJpSection />

      <Footer />

      <PurchaseButtons
        onAmazonClick={handleBuyOnAmazonClick}
        onRakutenClick={handleBuyOnRakutenClick}
        isAmazonSaleActive={isAmazonSaleActive}
      />
    </>
  )
}
